import { Button } from '@ab-inbev-maz/compass'

interface ButtonDownloadTemplateProps {
  fileName?: string;
  label?: string;
}



const ButtonDownloadTemplate = ({ fileName, label }: ButtonDownloadTemplateProps) => {
  const handleDownload = () => {
    if (!fileName) return;
    const link = document.createElement('a');
    link.href = fileName;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Button
      label={label || "Descargar template"}
      leftIcon="arrow/download"
      variant="primary"
      onClick={handleDownload}
      className="cursor-pointer"
    />
  )
}

export default ButtonDownloadTemplate;